export interface EShapeImageLike {
	url: string;
	width: number;
	height: number;
	source: TexImageSource;
}
